import { render, staticRenderFns } from "./global-reinstate-popup.vue?vue&type=template&id=6ac4ed14"
import script from "./global-reinstate-popup.vue?vue&type=script&lang=js"
export * from "./global-reinstate-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports